import React from "react";
import { withStyles, Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import Dialog from "components/shared/auth/dialog";
import DialogCloseButton from "components/shared/dialog_close_button";
import TwoActionModal from "components/shared/modals/two_action_modal";
import ThemeProvider from "components/shared/theme_provider";

const styles = (theme) => ({});

const UpdateDefaultOrDeleteModal = ({
  method,
  methodType,
  defaultMethod,
  isModalOpen,
  setIsModalOpen,
  actionType,
  handleUpdateDefault,
}) => {
  const typeText = methodType === "card" ? "CC" : "ACH";
  const methodInfoText = (method) =>
    methodType === "card"
      ? `${method.brand} ${method.last4}`
      : `${method.bankName} ${method.lastDigits}`;

  const isRemoving = ["removeCard", "removeACH"].includes(actionType);
  const updateId =
    methodType === "card" ? "customerCardId" : "paymentMethodUuid";

  const methodInfo = (
    <Grid container justifyContent="center">
      <Typography variant="h4">
        {`${methodInfoText(method)} ${
          isRemoving ? `(Default ${typeText})` : ""
        }`}
      </Typography>
    </Grid>
  );

  const handleMakeDefault = () => {
    handleUpdateDefault(method[updateId]);
    setIsModalOpen(false);
  };

  const makeDefaultTitle = `Are you sure you want to make this your Default ${typeText}?`;
  const makeDefaultBody = `Your current default ${methodInfoText(
    defaultMethod
  )} is being used for recurring payments. 
    Updating your default ${typeText} will also update the payment method for those recurring payments.`;

  const removeTitle = "Payment Method Still in Use";
  const removeBody = `This ${typeText} cannot be removed because it is currently being used for one or more recurring payments. 
    In order to remove it, you need to update your default payment method.`;

  const updateDefaultProps = {
    header: makeDefaultTitle,
    body: methodInfo,
    subtext: makeDefaultBody,
    leftButtonText: "Cancel",
    onClickLeftButton: () => setIsModalOpen(false),
    rightButtonText: "Proceed",
    onClickRightButton: () => handleMakeDefault(),
  };

  const removeProps = {
    header: removeTitle,
    body: methodInfo,
    subtext: removeBody,
    rightButtonText: "Got it",
    onClickRightButton: () => setIsModalOpen(false),
  };

  const modalProps = isRemoving ? removeProps : updateDefaultProps;

  return (
    <ThemeProvider>
      <Dialog open={isModalOpen}>
        <DialogCloseButton onClick={() => setIsModalOpen(false)} />
        <TwoActionModal {...modalProps} />
      </Dialog>
    </ThemeProvider>
  );
};

UpdateDefaultOrDeleteModal.defaultProps = {
  defaultMethod: {},
};

UpdateDefaultOrDeleteModal.propTypes = {
  classes: PropTypes.object.isRequired,
  method: PropTypes.object,
  methodType: PropTypes.string,
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  actionType: PropTypes.string.isRequired,
  defaultMethod: PropTypes.object,
  handleUpdateDefault: PropTypes.func,
};

export default withStyles(styles)(UpdateDefaultOrDeleteModal);
